/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

'use strict'

class Accordion {
  rootEl: HTMLElement
  buttonEl: HTMLButtonElement | null
  contentEl: HTMLElement | null
  iconToggleEl: HTMLElement | null
  isOpen: boolean

  constructor(domNode: HTMLElement) {
    this.rootEl = domNode
    this.buttonEl = this.rootEl.querySelector('button[aria-expanded]')
    this.contentEl = this.rootEl.querySelector('section')
    this.iconToggleEl = this.rootEl.querySelector('.icon__toggle')

    this.isOpen = this.buttonEl?.getAttribute('aria-expanded') === 'true'

    if (this.isOpen) {
      this.rootEl.classList.add('accordion--open')
    }

    if (this.iconToggleEl) {
      const initialEvent = this.isOpen ? 'toggle-toggle' : 'toggle-default'
      this.iconToggleEl.dispatchEvent(new CustomEvent(initialEvent))
    }

    this.buttonEl?.addEventListener('click', this.onButtonClick.bind(this))
  }

  onButtonClick() {
    this.toggle(!this.isOpen)
  }

  toggle(open: boolean) {
    if (open === this.isOpen) {
      return
    }

    this.isOpen = open

    this.rootEl.classList.toggle('accordion--open', open)

    if (this.buttonEl) {
      this.buttonEl.setAttribute('aria-expanded', `${open}`)
    }

    if (this.contentEl) {
      if (open) {
        this.contentEl.removeAttribute('hidden')
      } else {
        this.contentEl.setAttribute('hidden', '')
      }
    }

    if (this.iconToggleEl) {
      const eventName = open ? 'toggle-toggle' : 'toggle-default'
      this.iconToggleEl.dispatchEvent(new CustomEvent(eventName))
    }
  }

  open() {
    this.toggle(true)
  }

  close() {
    this.toggle(false)
  }
}

export function initAccordion() {
  const accordions = document.querySelectorAll('.accordion')
  accordions.forEach((accordionEl) => {
    if (accordionEl instanceof HTMLElement) {
      new Accordion(accordionEl)
    }
  })
}
